import React from 'react';
import styled from 'react-emotion';
import { FrenzyColor } from './FrenzyConstants';

const Outer = styled('div')`
  width: 50%;
  height: 2px;
  border: 2px solid ${FrenzyColor.BLUE};
  margin: 16px auto 2px auto;
  display: flex;
`;

type Props = {
  completionPercentage: number
};

const CompletionMeter:React.SFC<Props> = ({completionPercentage}) => {
	const finalFivePercentage = Math.min(5, completionPercentage);
	const remainingPercentage = Math.max(Math.min(completionPercentage, 100) - 5, 0);
	return (
		<Outer>
      <div 
        className="FinalFive"
        style={{
          backgroundColor: FrenzyColor.CYAN, 
          height: '100%',
          width: `${finalFivePercentage}%`
        }}
      />
			<div
        className="Remaining" 
        style={{
          backgroundColor: FrenzyColor.MAGENTA, 
          height: '100%',
          width: `${remainingPercentage}%`
        }}
      />
		</Outer>
	);
}

export default CompletionMeter;
